
const TEST_SERVER = window.location.hostname.toLowerCase().includes('localhost') || window.location.hostname.toLowerCase().startsWith('portal.test');

// TODO: Change this URL/endpoint after portal-api becomes billing-api.
export const BILLING_SERVICE_API_BASE = window.location.hostname === 'localhost' ? 'https://localhost:5210/api/v2/' : '/api/v2/';

export const MFA_SERVICE_API_BASE = window.location.hostname === 'localhost' ? 'https://localhost:5220/api/mfa/' : '/api/mfa/';

export const SALES_EMAIL = TEST_SERVER ? 'brett.scarlett@galacticadvisors.com' : 'miles.mittenthal@galacticadvisors.com';

export const SUPPORT_EMAIL = TEST_SERVER ? 'zack.puhl@galacticadvisors.com' : 'support@galacticadvisors.com';
